import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import {HistoryAction} from '../Actions/Models/HistoryActionModel';
import * as Types from '../../Models/HistoryModel';

export type State = Types.HistoryStore;

export const initialState: State = {
    carRideDetails: null,
    carRidesHistorySummary: null,
    activeCarRideId: null,
    currentCarIdRides: null,
    carTodaysRide: null,
    latestDataframes: null,
    activeDataframe: null,
    latestDataframesManualHandling: true,
    currentSingleRideBoundsCentroid: {
        bounds: null,
        centroid: null
    },
    currentFullRideBoundsCentroid: {
        bounds: null,
        centroid: null
    },
    rideListIndex: null,
    latestDataframesQuery: null
};

export function historyReducer(state: State = initialState, action: HistoryAction): State {
    switch (action.type) {
        case ActionTypes.History.GET_CAR_RIDES_HISTORY_SUCCESS: {
            return {
                ...state,
                carRidesHistorySummary: action.payload.carRidesHistorySummary,
                currentFullRideBoundsCentroid: action.payload.fullPathBoundsCentroid
            };
        }
        case ActionTypes.History.GET_CAR_RIDES_HISTORY_FAILURE: {
            return {
                ...state,
                carRidesHistorySummary: null
            };
        }
        case ActionTypes.History.GET_CAR_RIDE_DETAILS_SUCCESS: {
            return {
                ...state,
                carRideDetails: action.payload.carRideDetails
            };
        }
        case ActionTypes.History.GET_CAR_RIDE_DETAILS_FAILURE: {
            return {
                ...state,
                carRideDetails: null
            };
        }
        case ActionTypes.History.GET_CAR_TODAYS_RIDE_SUCCESS: {
            return {
                ...state,
                carTodaysRide: action.payload.carTodaysRide,
                currentCarIdRides: action.payload.currentCarIdRides,
            };
        }
        case ActionTypes.History.SET_ACTIVE_CARRIDE: {
            return {
                ...state,
                activeCarRideId: action.payload.carRideId,
                currentSingleRideBoundsCentroid: action.payload.fullPathBoundsCentroid || initialState.currentSingleRideBoundsCentroid
            };
        }
        case ActionTypes.History.GET_LATEST_DATAFRAMES_SUCCESS: {
            return {
                ...state,
                latestDataframes: action.payload.dataframes
            };
        }
        case ActionTypes.History.SET_ACTIVE_DATAFRAME: {
            return {
                ...state,
                activeDataframe: action.payload.activeDataframe
            };
        }
        case ActionTypes.History.CLEAR_RIDE_DETAILS: {
            return {
                ...state,
                activeCarRideId: initialState.activeCarRideId,
                carRideDetails: initialState.carRideDetails,
            };
        }
        case ActionTypes.History.CLEAR_HISTORY_RIDES: {
            return {
                ...state,
                carRidesHistorySummary: initialState.carRidesHistorySummary,
            };
        }
        case ActionTypes.History.SAVE_RIDE_LIST_INDEX: {
            return {
                ...state,
                rideListIndex: action.payload.rideListIndex,
            };
        }
        case ActionTypes.History.SAVE_LATEST_DATAFRAMES_QUERY: {
            return {
                ...state,
              latestDataframesQuery: action.payload.latestDataframesQuery,
            };
        }
        case ActionTypes.History.TOGGLE_LATEST_DATAFRAMES_MANUAL_HANDLING: {
            return {
                ...state,
              latestDataframesManualHandling: action.payload.latestDataframesManualHandling,
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/HistoryReducer.ts